import {
  IAutoComplete,
  VIEW_LIMIT,
} from '@store/redux/features/search/searchSlice';
// import { removeLastWord } from '@utils/removeLastWord/removeLastWord';

export function makeGetNewInput(
  // searchText: string,
  autocompleteOptions: IAutoComplete[],
  recentSearches: string[],
  option: number,
) {
  return () => {
    // const updatedSearch = removeLastWord(searchText);
    // autocompleteOptions &&
    // recentSearches &&
    if (option < autocompleteOptions.length) {
      return `${autocompleteOptions[option].labelOne}`;
      // return updatedSearch.length > 0
      //   ? `${updatedSearch} ${autocompleteOptions[option].labelOne}`
      //   : `${autocompleteOptions[option].labelOne}`;
    }

    // autocompleteOptions &&
    // recentSearches &&
    // recentSearches &&
    if (
      option >= autocompleteOptions.length &&
      option <
        autocompleteOptions.length + recentSearches.slice(0, VIEW_LIMIT).length
    ) {
      return `${recentSearches[option - autocompleteOptions.length]}`;
    }
    return '';
  };
}
